const menu = document.querySelector(".menu");
const menuToggler = document.querySelector(".menu-toggler");
if (menuToggler) {
    menuToggler.addEventListener("click", () => {
        menu.classList.toggle("menu-is-open");
        const icon = document.querySelector(".menu-toggler-icon");
        const isMenuOpen = menu.classList.contains("menu-is-open");
        icon.innerHTML = `<use xlink:href="${import.meta.env.BASE_URL}images/icons/icon-sprite.svg?v=20250829#icon-domea-${isMenuOpen ? "close" : "menu"}"></use>`;
    });
}